import { FC, ReactElement, useRef } from 'react';
import { FeedHandle } from '../feed/feed.tsx';
import { PostFeed, PostFeedProps } from './post-feed.tsx';
import {
  COMPACT_FEED_SCROLL_LOCK_DELTA,
  SCROLL_LOCK_DELTA,
  useFeedScrollLock,
} from './use-feed-scroll-lock.ts';

export { COMPACT_FEED_SCROLL_LOCK_DELTA, SCROLL_LOCK_DELTA };

export const SubscribedPostFeed: FC<
  PostFeedProps & {
    subscription?: (onData: () => void) => ReactElement;
    loading?: boolean;
    newPostsButtonClassName?: string;
    outdated?: boolean;
    lockFeedPosition?: boolean;
  }
> = ({
  subscription,
  loading,
  style,
  lockFeedPosition,
  data,
  compactFeed,
  gap,
  totalListHeightChanged,
  ...props
}) => {
  const feedRef = useRef<FeedHandle>(null);

  const { presentedData, handleTotalListHeightChanged } = useFeedScrollLock({
    data,
    feedRef,
    compactFeed,
    lockFeedPosition,
    onTotalListHeightChanged: totalListHeightChanged,
  });

  return (
    <>
      <PostFeed
        {...props}
        feedRef={feedRef}
        style={{
          opacity: loading ? 0.5 : '',
          ...style,
        }}
        data={presentedData}
        compactFeed={compactFeed}
        gap={gap}
        totalListHeightChanged={handleTotalListHeightChanged}
      />
      {subscription
        ? // eslint-disable-next-line react-hooks/refs
          subscription(() => {})
        : null}
    </>
  );
};
